import { render, staticRenderFns } from "./AccountVerificationButtons.vue?vue&type=template&id=348c755a&scoped=true&"
import script from "./AccountVerificationButtons.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c755a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348c755a')) {
      api.createRecord('348c755a', component.options)
    } else {
      api.reload('348c755a', component.options)
    }
    module.hot.accept("./AccountVerificationButtons.vue?vue&type=template&id=348c755a&scoped=true&", function () {
      api.rerender('348c755a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/AccountVerificationButtons.vue"
export default component.exports